import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { of, Subject } from 'rxjs';
import { catchError, map, takeUntil } from 'rxjs/operators';
import { FileService } from 'src/app/services/file/file.service';

@Component({
  selector: 'app-upload-meta-data',
  templateUrl: './upload-meta-data.component.html',
  styleUrls: ['./upload-meta-data.component.sass']
})
export class UploadMetaDataComponent implements OnInit, OnDestroy {

  /** UI related variables */
  ui: {
    selectedFiles: File[]
    _selectedFiles: any // is FileList
    uploading: boolean
    progress: number
  } = {
      _selectedFiles: null,
      selectedFiles: [],
      uploading: false,
      progress: 0
    }

  unsubber$ = new Subject()

  constructor(
    private fileService: FileService
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.unsubber$.next()
    this.unsubber$.unsubscribe()
  }

  onFileSelected(evt) {
    

    this.ui.selectedFiles = []

    this.ui._selectedFiles = evt
    for (let i = 0; i < evt.length; i++) {
      const file = evt.item(i)

      this.ui.selectedFiles.push(file)
    }
  }

  onCancelClicked() {
    this.ui.selectedFiles = []
    this.ui.progress = 0
    this.ui.uploading = false
  }

  async onUploadClicked() {
    const formData = new FormData()
    formData.append('images', this.ui._selectedFiles)

    this.ui.uploading = true

    this.fileService.uploadMeta(formData, { reportProgress: true, observe: 'events' })
      .pipe(
        takeUntil(this.unsubber$.asObservable()),
        map((res: HttpEvent<any>) => {
          switch (res.type) {
            case HttpEventType.UploadProgress: {
              this.ui.progress = Math.round(res.loaded / res.total * 100)
              break
            }
            case HttpEventType.Response: {
              return res
            }
          }
        })
      )
      .subscribe(
        (res) => { },
        (error) => { console.error(error) },
        () => { this.ui.uploading = false }
      )
  }

}
